module.exports = {
        srcSet: "/_next/static/images/apple@3x-130-743c73a2aaf1e54e.png"+" 130w"+","+"/_next/static/images/apple@3x-260-f7516633602dc54f.png"+" 260w"+","+"/_next/static/images/apple@3x-390-10c59a696477ac1b.png"+" 390w",
        images: [{path: "/_next/static/images/apple@3x-130-743c73a2aaf1e54e.png",width: 130,height: 44},{path: "/_next/static/images/apple@3x-260-f7516633602dc54f.png",width: 260,height: 88},{path: "/_next/static/images/apple@3x-390-10c59a696477ac1b.png",width: 390,height: 132}],
        src: "/_next/static/images/apple@3x-390-10c59a696477ac1b.png",
        toString: function(){return "/_next/static/images/apple@3x-390-10c59a696477ac1b.png"},
        
        width: 390,
        height: 132
      }